export const START_IMPERSONATION__REQUEST =
  "IMPERSONATION > START IMPERSONATION > REQUEST";
export const START_IMPERSONATION__SUCCESS =
  "IMPERSONATION > START IMPERSONATION > SUCCESS";
export const START_IMPERSONATION__ERROR =
  "IMPERSONATION > START IMPERSONATION > ERROR";

export const IS_IMPERSONATING__REQUEST =
  "IMPERSONATION > IS IMPERSONATING > REQUEST";
export const IS_IMPERSONATING__SUCCESS =
  "IMPERSONATION > IS IMPERSONATING > SUCCESS";
export const IS_IMPERSONATING__ERROR =
  "IMPERSONATION > IS IMPERSONATING > ERROR";

export const STOP_IMPERSONATION__REQUEST =
  "IMPERSONATION > STOP IMPERSONATION > REQUEST";
export const STOP_IMPERSONATION__SUCCESS =
  "IMPERSONATION > STOP IMPERSONATION > SUCCESS";
export const STOP_IMPERSONATION__ERROR =
  "IMPERSONATION > STOP IMPERSONATION > ERROR";
